// Allow time for Ant Design drawer animation to complete before focusing input
export const DRAWER_RENDER_DELAY_MS = 100;

export const AUTO_FOCUS_FIELDS = new Set([
  'makes',
  'mfrs',
  'engine_fuel_types',
  'engine_base_block_types',
  'engine_fuel_delivery_types',
  'transmission_base_types',
  'body_doors',
  'front_spring_types',
  'bed_lengths',
  'front_brake_types',
  'steering_types',
  'drives',
  'wheel_bases',
  'mfr_body_codes',
  'positions',
]);
